import { PropsWithChildren } from "react";
import {
  Button,
  HStack,
  Popover,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Text,
} from "@chakra-ui/react";
import { ChevronDown } from "icons";

type PopoverFilterProps = {
  isSet: boolean;
  name: string;
  buttonName?: string;
} & PropsWithChildren;

const PopoverFilter = ({
  isSet,
  name,
  buttonName,
  children,
}: PopoverFilterProps) => (
  <Popover isLazy returnFocusOnClose={false}>
    <PopoverTrigger>
      <Button
        variant={isSet ? "primary" : "outline"}
        borderColor={isSet ? "gray.400" : "gray.500"}
        bg={isSet ? "gray.400" : "unset"}
        _hover={{
          bg: isSet ? "gray.500" : "gray.50",
          borderColor: "gray.500",
        }}
        rightIcon={<ChevronDown />}
        borderRadius="12px"
        size="md"
        fontSize="sm"
        borderWidth="1px"
        colorScheme="gray"
        aria-label={`${buttonName ?? name} filter, ${
          isSet ? "active" : "inactive"
        }`}
      >
        {buttonName ?? name}
      </Button>
    </PopoverTrigger>

    <PopoverContent
      borderRadius="8px"
      boxShadow="2xl"
      border="none"
      width="auto"
      data-focus-visible-disabled
    >
      <HStack
        color="gray.700"
        p={4}
        textAlign="left"
        justifyContent="space-between"
      >
        <Text fontSize="sm" fontWeight="bold" color="inherit">
          {name}
        </Text>
        <PopoverCloseButton color="inherit" position="static" />
      </HStack>

      {children}
    </PopoverContent>
  </Popover>
);

export default PopoverFilter;
